<template>
  <v-layout align-center justify-center>
    <v-flex xs11 sm12 md8 lg8>
      <app-snack-bar></app-snack-bar>
      <v-card class="app-card mt-3">
        <!-- <v-card-title class="app-card-title">Cadastro de Empresa</v-card-title> -->
        <v-card-text class="app-card-content">
          <div class="layout column align-center">
            <img src="../../assets/images/logo.svg" alt="Logo Sistransce" class="logo" />
            <h4 class="text-center font-weight-bold">Cadastro de Empresa</h4>
          </div>
          <v-alert text dense color="info" icon="info" border="left">
            Após finalizar o cadastro abaixo entraremos em contato informando o
            andamento da solicitação e próximos passos.
          </v-alert>

          <v-alert type="warning" class="mt-2" v-if="form.error">
            {{ form.error }}
          </v-alert>

          <v-stepper outlined alt-labels class="app-stepper" v-model="form.currentStep">
            <v-stepper-header class="app-stepper-header">
              <v-stepper-step
                step="1"
                class="app-stepper-header__step"
                color="success"
                :complete="form.currentStep > 1"
              >Empresa</v-stepper-step>
              <v-spacer></v-spacer>
              <v-stepper-step
                step="2"
                class="app-stepper-header__step"
                color="success"
                :complete="form.currentStep > 2"
                :editable="form.currentStep === 3"
              >Documentos</v-stepper-step>
              <v-spacer></v-spacer>
              <v-stepper-step
                step="3"
                class="app-stepper-header__step"
                color="success"
                :complete="form.currentStep > 3"
              >Pagamento</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content step="1">
                <EmpresaForm @orderCreated="handlerCreateOrder" />
              </v-stepper-content>
              <v-stepper-content step="2">
                <OrderDocumentListPublic
                  v-if="order"
                  :order="order"                   
                  :secretToken="orderSecretToken"
                  @documentsCreated="handlerUploadDocuments"
                />
              </v-stepper-content>
              <v-stepper-content step="3">
                <PagamentoForm @handlerPayment="handlerPayment" />
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import EmpresaForm from "./EmpresaForm";
import OrderDocumentListPublic from "../orders/components/OrderDocumentListPublic";
import PagamentoForm from "./PagamentoForm";
import GlobalStore from "@/store/modules/global";
import AppSnackBar from "@/components/AppSnackBar";

import { APP_PREFIX_AUTH } from "@/commons/config"

const LOCALSAVE = `${APP_PREFIX_AUTH}@cadastroEmpresa`

export default {
  name: "Registration",
  
  components: {
    EmpresaForm,
    OrderDocumentListPublic,
    PagamentoForm,
    AppSnackBar
  },

  data: () => ({
    form: {
      currentStep: 1,
      error: null,
    },

    order: null,

    orderSecretToken: null,
  }),

  methods: {
    handlerCreateOrder({order, token}) {
      this.order = order;
      this.orderSecretToken = token;
      this.nextStep();
    },

    handlerUploadDocuments() {      
      this.nextStep();
    },

    handlerPayment() {      
      this.setCurrentStep(1);
    },

    nextStep() {
      this.form.currentStep++;
    },

    prevStep() {
      this.form.currentStep--;
    },

    setCurrentStep(step) {
      this.form.currentStep = step;
    }
  },
  
};
</script>

<style lang="scss" scoped>
.logo {
  width: 275px;
  margin: 0px auto 20px auto;
  display: table;
}
</style>
